var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 367.022,
    height: 383.631,
    viewBox: "0 0 367.022 383.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 367.022,
    height: 383.631,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_760",
    x: 115.929,
    y: 58.495,
    width: 245.576,
    height: 185.749,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: -0.174,
    x2: 0.783,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7110e3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_5",
    x: 165.824,
    y: 175.558,
    width: 201.199,
    height: 208.073,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.13,
    y1: 0.147,
    x2: 0.828,
    y2: 0.958,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_819",
    x: 252.343,
    y: 328.491,
    width: 28.16,
    height: 37.32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_822",
    x: 183.643,
    y: 268.952,
    width: 37.32,
    height: 28.16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_4",
    x: 243.183,
    y: 213.992,
    width: 77.866,
    height: 92.28,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "events",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "events-2",
    "data-name": "events",
    transform: "translate(-290 -1425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-star_half_empty",
    transform: "translate(618.084 1762.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M14.083,4,17.2,10.29,24.166,11.3l-5.042,4.946,1.2,6.914-6.242-3.265L7.841,23.158l1.2-6.914L4,11.3l6.962-1.008Z",
    transform: "translate(-4 -4)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M14.02,19.893V4l-3.1,6.29L4,11.3l5.01,4.946L7.817,23.158Z",
    transform: "translate(-4 -4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M3.592-202.666H205.777a3.592,3.592,0,0,1,3.592,3.592V-33.3a3.592,3.592,0,0,1-3.592,3.592H3.592A3.592,3.592,0,0,1,0-33.3V-199.073A3.592,3.592,0,0,1,3.592-202.666Z",
    transform: "translate(290 1757.384)",
    fill: "#efedec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M91.779-128.435c2.476-1.081,34.544-11.51,34.544-11.51s10.751,11.51,11.4,19.277S127.3-94.43,127.3-94.43,88.521-115.044,84.61-118.256,81.351-123.881,91.779-128.435Z",
    transform: "translate(306.265 1769.764)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M0-137.3C59.467-123.526,200.983-40.5,209.37-36.461v-24.7c-66.725-34.42-105.127-49.857-105.464-54.552-.529-7.381,97.392-24.285,105.464-31.953v-20.793c-6.1,2.026-84.324,27.834-112.74,26.66C73.9-142.733,6.874-162.477,0-164.517Z",
    transform: "translate(290 1764.136)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M0-134.244s47.7,16.932,68.544,27.952c41.468,21.921,105.374,59.47,109.54,63.078H134.117S86.094-82.392,76.41-85.206A177.554,177.554,0,0,1,47.924-96.8c-6.87-3.584-14.467-10.232-19.688-12.535C22.223-111.993,0-118.382,0-118.382Z",
    transform: "translate(290 1770.889)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M98.7-76.3c-5.275-2.469-9.823-4.6-13.7-6.251-3.321-1.412-7.77-3.209-12.516-5.126-10.963-4.43-24.6-9.94-27.363-12.045C41.275-102.672,19.57-87.759,0-73.091v3.248c19.338-14.5,40.088-28.379,43.148-28.115C46.218-95.614,58.92-90.483,71.2-85.52c4.722,1.907,9.154,3.7,12.457,5.1,3.827,1.629,8.363,3.752,13.6,6.207,5.56,2.6,11.917,5.563,18.89,8.629-3.99,3.7-10.788,9.873-17.139,15.629h3.937c6.083-5.511,12.295-11.165,15.866-14.485a370.855,370.855,0,0,0,38.861,14.485h8.951C138.923-57.573,115.38-68.493,98.7-76.3Z",
    transform: "translate(290 1777.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M16.21-177.2l50.836-23.575L87.07-182.045l-14.429,4.684,1.064,2.234,71.477-23.215L153.3-185.3a1.506,1.506,0,0,0,1.291.653,1.771,1.771,0,0,0,.355-.034L189.9-191.9l3.024,9.561,2.809-.61L189.5-202.666h-3.007l2.669,8.437-33.8,6.986L147.9-199.226l10.591-3.44H150.55l-60.6,19.684-20.309-19,1.489-.687h-6.1l.052.053-50.3,23.325Z",
    transform: "translate(292.918 1757.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M39.611-175.218l-2.687.913c1.64,3.291,7.235,14.125,10.387,15.427,3.007,1.24,21.873,1.648,26.1,1.725,2.1,4.151,4.531,7.807,7.13,9.378,2.245,1.36,5.938,1.85,10.1,1.85,9.974,0,22.653-2.815,24.6-3.262.023,0,.035-.029.052-.034l.006.019,51.86-14.014a1.21,1.21,0,0,0,.989-1.288L166.2-177.716l-2.885.293,1.791,12.232-49.074,13.26-4.118-24.2-2.879.331,1.407,8.273-38.14.629c-1.384-3.723-2.466-7.173-3.065-9.335l-2.832.533a122.8,122.8,0,0,0,5.833,16.114c-10.655-.221-22.065-.8-23.636-1.446C47.1-161.684,42.757-168.91,39.611-175.218Zm71.25,10.094,2.367,13.9c-7.9,1.7-25.764,4.675-30.963,1.518-3.245-1.965-6.52-8.465-9.032-14.8Z",
    transform: "translate(297.288 1762.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M184.083-89.07l-51.65-20.13a43.742,43.742,0,0,0,2.419-8.975h15.267a14.246,14.246,0,0,0,10.922,6.3c3.7.307,16.209,1.4,23.042,2v-2.417c-6.9-.605-19.1-1.672-22.757-1.975a11.359,11.359,0,0,1-8.666-5.059c1.32-1.744,4.443-4.968,7.886-5.16,3.5-.192,15.249-1.686,23.531-2.772V-129.7c-8.258,1.086-20.3,2.618-23.723,2.806-5.106.283-8.91,4.646-10.178,6.3H134.916a23.2,23.2,0,0,0-3.257-9.763l52.424-12.568v-2.5l-54.93,13.178a1.408,1.408,0,0,0-.942.7,1.03,1.03,0,0,0,.087,1.047c.041.063,4.147,6.053,3.809,11.05-.3,4.362-2.8,10.421-2.832,10.483a1.134,1.134,0,0,0,.756,1.48l54.052,21.062Z",
    transform: "translate(315.286 1768.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M208.788-69.327,148.3-97.582c-3.931-1.834-6.194-5.411-5.775-9.138.768-6.864,1.832-17.335,1.471-19.565-.628-3.9-4.862-25.31-5.281-28.969-.785-6.9,5.769-10.548,11.353-12.064s59.3-12.643,59.3-12.643v-11.3l-67.609,14.275s-34.22-2.583-56.809-4.2c-18.907-1.357-32.912,1.39-46.143.328C27.5-181.766,0-191.262,0-191.262v9.655c4.158,2.51,24.333,8.776,37.256,10.138s38.454-1.077,47.131-.463c10.562.748,45.718,4.422,45.718,4.422s-4.594,3.978-2.739,11.774c2.222,7.777,6.072,28.356,6.746,31.721.413,2.052-.936,11.716-1.809,17.48a9.977,9.977,0,0,1-4.938,6.937L15.738-31.959H34.691L133.217-90.3a5.244,5.244,0,0,1,4.763-.217L209.37-57.3Z",
    transform: "translate(290 1759.635)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M121.361-117.837c.4-3.619.887-8.2,1.212-12.139l-10.121-.467c-.392,3.961-1.128,9.136-1.677,12.8a8.6,8.6,0,0,1-.235.853l10.881-.125A8,8,0,0,1,121.361-117.837Z",
    transform: "translate(311.819 1771.639)",
    fill: "#ffe081"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 290, 1425)",
    filter: "url(#Path_760)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760-2",
    "data-name": "Path 760",
    d: "M108.335-256.137H335.91v143.785a23.961,23.961,0,0,1-23.955,23.964H132.29a23.961,23.961,0,0,1-23.955-23.964Z",
    transform: "translate(16.59 320.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M335.91-271.473v35.779H108.335v-35.779a23.905,23.905,0,0,1,23.955-23.852H311.955a23.905,23.905,0,0,1,23.955,23.852",
    transform: "translate(306.594 1739.094)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M264.3-276.122a15.222,15.222,0,0,1-15.161,15.285,15.222,15.222,0,0,1-15.161-15.285,15.222,15.222,0,0,1,15.161-15.285A15.222,15.222,0,0,1,264.3-276.122",
    transform: "translate(337.861 1742.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M173.926-276.122a15.222,15.222,0,0,1-15.161,15.284A15.222,15.222,0,0,1,143.6-276.122a15.222,15.222,0,0,1,15.161-15.284,15.222,15.222,0,0,1,15.161,15.284",
    transform: "translate(321.22 1742.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M250.222-311a11.972,11.972,0,0,0-11.944,11.991v29.979a11.972,11.972,0,0,0,11.944,11.991,11.972,11.972,0,0,0,11.944-11.991v-29.979A11.972,11.972,0,0,0,250.222-311",
    transform: "translate(337.032 1736)",
    fill: "#b0bdc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M160.446-311A11.972,11.972,0,0,0,148.5-299.009v29.979a11.972,11.972,0,0,0,11.944,11.991A11.972,11.972,0,0,0,172.39-269.03v-29.979A11.972,11.972,0,0,0,160.446-311",
    transform: "translate(319.312 1736)",
    fill: "#b0bdc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M53.942-75.484c8.8,0,15.93-2.517,15.93-5.622s-7.132-5.622-15.93-5.622-15.93,2.517-15.93,5.622S45.144-75.484,53.942-75.484Z",
    transform: "translate(297.503 1780.268)",
    fill: "rgba(87,32,151,0.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(462.423 1525.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(72.086 72.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(108.086 73.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(36.086 73.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(108.086 1.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(108.086 36.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(0.086 72.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(0.086 36.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(36.086 36.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(72.086 36.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(0.086 0.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(36.086 0.051)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(73.086 0.051)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M53.957-114.6A13.731,13.731,0,0,0,40.3-100.8c0,7.626,13.655,25.64,13.655,25.64S67.612-93.172,67.612-100.8A13.731,13.731,0,0,0,53.957-114.6Zm0,21.24a6.069,6.069,0,0,1-6.069-6.069,6.069,6.069,0,0,1,6.069-6.069,6.069,6.069,0,0,1,6.069,6.069A6.069,6.069,0,0,1,53.957-93.364Z",
    transform: "translate(297.955 1774.766)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 290, 1425)",
    filter: "url(#Union_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5-2",
    "data-name": "Union 5",
    d: "M0,98.473A91.627,91.627,0,0,1,79.494,7.667c-.023-.544-.036-1.091-.036-1.642,0-2.037.188-4.025.314-6.026h24.746V7.778A91.6,91.6,0,1,1,0,98.473Z",
    transform: "translate(174.82 181.56)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M307.863-65.051A73.271,73.271,0,0,1,234.584,8.229,73.271,73.271,0,0,1,161.3-65.051a73.274,73.274,0,0,1,73.279-73.279A73.277,73.277,0,0,1,307.863-65.051Z",
    transform: "translate(321.839 1770.083)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M291.958-66.96c0-39.418-30.876-71.37-68.969-71.37-1.448,0-2.884.063-4.31.152V-62.5h73.1C291.872-63.976,291.958-65.457,291.958-66.96Z",
    transform: "translate(337.744 1770.083)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 290, 1425)",
    filter: "url(#Path_819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819-2",
    "data-name": "Path 819",
    d: "M218.679-13.14c1.521.092,3.032.229,4.58.229s3.059-.137,4.58-.229V-31.231h-9.16Z",
    transform: "translate(43.16 366.22)",
    fill: "#fff",
    stroke: "rgba(99,74,233,0.41)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 290, 1425)",
    filter: "url(#Path_822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822-2",
    "data-name": "Path 822",
    d: "M161.533-71.8h18.091v-9.16H161.533c-.092,1.521-.229,3.032-.229,4.58S161.442-73.316,161.533-71.8Z",
    transform: "translate(31.84 356.41)",
    fill: "#fff",
    stroke: "rgba(99,74,233,0.41)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 290, 1425)",
    filter: "url(#Union_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4-2",
    "data-name": "Union 4",
    d: "M0,59.539A13.75,13.75,0,0,1,9.16,46.582V0h9.16V46.582a13.785,13.785,0,0,1,8.4,8.44H58.866V66.229H25.742A13.74,13.74,0,0,1,0,59.539Z",
    transform: "translate(252.68 220.49)",
    fill: "#fff",
    stroke: "rgba(99,74,233,0.51)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M227.839-76.375a4.588,4.588,0,0,1-4.58,4.58,4.587,4.587,0,0,1-4.58-4.58,4.587,4.587,0,0,1,4.58-4.58,4.588,4.588,0,0,1,4.58,4.58",
    transform: "translate(333.164 1781.407)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.9524d915c47f6517a98868d7b41b61f3.svg";
export { ForwardRef as ReactComponent };